<div #capture id="capture-wrapper">
    <mat-card class="field">
        <mat-card-content>
        <div class="header">
            <h2>{{ form.get('name')?.value }}</h2>
            <div class="lineup flex">{{ form.get('formation')?.value }}</div>
        </div>

        <div *ngFor="let p of positions" 
            class="player-position" 
            [ngStyle]="{'left': p.x, 'top': p.y, 'transform':'translate(-'+p.x+', -'+p.y+')'}">

            <div class="position">
                <button *ngIf="editMode" (click)="openDialog(p.starterPositionId)" class="add-button">
                    <p *ngIf="!p.player && p.starterPositionId !== submitted" class="plus">+</p>
                    <mat-spinner class="spinner" [diameter]="20" *ngIf="p.starterPositionId === submitted"></mat-spinner>
                </button>

                <div *ngIf="p.player" class="card-wrapper">
                    <player-card 
                        [player]="p.player" 
                        [flag]="form.get('badge')?.value!" 
                        [blue]="isBlue(p.player)" 
                        class="player-card">
                    </player-card>

                    <div *ngIf="p.subPlayer && form.get('sub')?.value" class="sub">
                        <div class="flex sub-wrapper" [ngClass]="{
                            'red-bg': isSubBgRed(p.subPlayer.currentTeam),
                            'blue-bg': !isSubBgRed(p.subPlayer.currentTeam)
                        }">
                            <span>{{ p.subPlayer.commonName || p.subPlayer.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </mat-card-content>
    </mat-card>
</div>
